import { useCallback, useEffect, useState } from "react";
import * as GuardiansV2API from "@/services/api/guardiansv2";
import type { MissionConversation } from "@/services/api/guardiansv2/types";

export interface UseMissionConversationOptions {
  missionId?: string | null;
  taskId?: string | null;
  enabled?: boolean;
}

export function useMissionConversation({
  missionId,
  taskId,
  enabled = true,
}: UseMissionConversationOptions) {
  const [data, setData] = useState<MissionConversation | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!enabled) return;
    if (!missionId && !taskId) {
      setData(null);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const doc = missionId
        ? await GuardiansV2API.getMissionConversation(missionId)
        : await GuardiansV2API.getTaskConversation(taskId!);
      setData(doc);
    } catch (err) {
      setData(null);
      setError(err instanceof Error ? err.message : "Failed to load conversation");
    } finally {
      setLoading(false);
    }
  }, [enabled, missionId, taskId]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { data, loading, error, reload };
}
